import * as yup from 'yup';

export const CreateSubjectFormValidation = yup.object().shape({
    description: yup.string().required('Descrição é obrigatória'),
    isCore: yup.bool().oneOf([true, false], 'Inválido').required('Obrigatório'),
    hasExam: yup.bool().oneOf([true, false], 'Inválido').required('Obrigatório'),
    isMonograph: yup.bool().oneOf([true, false], 'Inválido'),
    idScientificArea: yup.string().required('Área cientifica Obrigatória')
});